import React from "react";
import { Dialog, DialogContent } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { X } from "lucide-react";

const LandingModal = ({ open, onOpenChange, campaign, onComplete }) => {
  if (!campaign) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <div className="relative text-center">
          <Button variant="ghost" size="icon" className="absolute right-0 top-0" onClick={() => onOpenChange(false)}>
            <X className="h-4 w-4" />
          </Button>
          <div className="flex flex-col items-center">
            {campaign.logo && <div className="text-3xl mb-2">{campaign.logo}</div>}
            {campaign.image && (
              <img src={campaign.image} alt={campaign.name} className="w-full rounded-xl max-h-32 object-contain my-2" />
            )}
            <h3 className="text-xl font-bold mt-2">{campaign.name}</h3>
            <p className="text-slate-500 text-sm my-2">{campaign.description}</p>
            <div className="flex flex-wrap gap-3 justify-center mt-4">
              <Button onClick={() => onComplete('Max')} className="bg-blue-600 hover:bg-blue-700">
                🚀 Через Max
              </Button>
              <Button onClick={() => onComplete('Telegram')} className="bg-sky-500 hover:bg-sky-600">
                📱 Telegram
              </Button>
              <Button onClick={() => onComplete('СМС')} className="bg-emerald-600 hover:bg-emerald-700">
                ✉️ Через смс
              </Button>
            </div>
            <div className="text-[10px] text-slate-400 mt-4">
              UTM: {campaign.utmSource} / {campaign.utmCampaign}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LandingModal;